import { Input, Checkbox, Form, Divider } from "antd";
import ContentPadding from "../ContentConfig/ContentPadding";
import FormCustomIDField from "../ContentConfig/FormCustomIDField";
import TrimmedInput from "../FormCommonField/FormTrimmedInput";

export default ({ node }) => {
  const defalutLabel = node?.data?.label || ""

  return (
    <>
      <Form.Item
        label="Label"
        name="label"
        rules={[{ required: true, max: 256 }]}
      >
        <TrimmedInput/>
        </Form.Item>
      <Form.Item name="hideLabel" valuePropName="checked">
        <Checkbox>Hide Label</Checkbox>
      </Form.Item>
      <FormCustomIDField />
      <Form.Item label="Placeholder" name="placeholder">
        <Input maxLength={50} style={{ 
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }}/>
      </Form.Item>
      <Form.Item name="required" valuePropName="checked">
        <Checkbox>Required</Checkbox>
      </Form.Item>
      <Form.Item label="Max" name="max">
        <Input type="number" />
      </Form.Item>
      <Form.Item label="Min" name="min">
        <Input type="number" />
      </Form.Item>
      <strong>Style</strong>
      <Divider style={{margin: "12px 0"}} />
      <ContentPadding />
    </>
  );
};
